import app from '../../../main'

export default {
    namespaced: true,
    state: {
        suppliers: [],
        mobileSuppliers: [],
        pagination: {
            page: 1,
            totalPages: 1,
            totalProducts: 0,
            pageSize: 10
        },
        errors: {
            getSuppliers: {}
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        },
        CLEAR_SUPPLIERS(state) {
            state.suppliers = []
            state.mobileSuppliers = []
            state.pagination = {
                page: 1,
                totalPages: 1,
                totalProducts: 0,
                pageSize: 10
            }
        },
        SET_SUPPLIERS(state, payload) {
            state.suppliers = payload
        },
        SET_MOBILE_SUPPLIERS(state, payload) {
            if (state.pagination.page == 1) {
                state.mobileSuppliers = payload
            } else {
                state.mobileSuppliers = [...state.mobileSuppliers, ...payload]
            }
        },
        SET_PAGINATION(state, payload) {
            state.pagination[payload.key] = payload.val
        }
    },
    actions: {
        clearSuppliers({ commit }) {
            commit('CLEAR_SUPPLIERS')
        },
        async getSuppliers({ commit, state }, data) {
            commit('SET_ERRORS', {
                key: 'getSuppliers',
                val: {}
            })

            const url = '/supplier/statistics/global/suppliers'

            try {
                const resp = await this.$axios.get(url, {
                    params: {
                        ...data,
                        items: state.pagination.pageSize
                    }
                })
                app.$Progress.finish()

                commit('SET_SUPPLIERS', resp.data)

                commit('SET_PAGINATION', {
                    key: 'page',
                    val: resp.headers['page'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalPages',
                    val: resp.headers['total-pages'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalProducts',
                    val: resp.headers['total-records'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'pageSize',
                    val: resp.headers['page-size'] * 1
                })

                if (
                    (data && data.isMobilePagination) ||
                    state.pagination.page == 1
                ) {
                    commit('SET_MOBILE_SUPPLIERS', resp.data)
                }
            } catch (e) {
                app.$Progress.fail()
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getSuppliers',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getSuppliers',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        }
    }
}
